import FillRateWidgetContainer from "./FillRateWidgetContainer";
export type { FillRateApiResponse } from "./FillRate";

export default FillRateWidgetContainer;
